const globalupdate = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Global Update',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "News",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": false,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New News",
                                "type": "page",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'News Title',
                                    "placeholder": 'Enter News Title',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                    "practices": {
                                        "type": 'practiceMultiSelect',
                                        "label": 'Practice(s)',
                                        "placeholder": 'Select Practice',
                                        "load_url": '',
                                        "required": true,
                                        "info": false,
                                        "character_count": 0,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                },
                                "additionalProps": {
                                    "date": "",
                                    "featured": false,
                                    // "slug": "",
                                    "media_type":"Video",
                                    "image_url":"",
                                    "video_url":"",
                                    "global":true,
                                    // "upload_type": "",
                                    // "upload_url": "",
                                }
                            },
                        },
                        "children": [
                            {
                                "type": "newsTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Select a News",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ],
                                    "onlyGlobal": true,                                
                                    "isGlobal": true,
                                    "global": {
                                        "label": "Select a News",
                                        "type": "list",
                                        "info": true,
                                        "size": "4",
                                        "style": "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                        "class": "p-0 pt-3 pr-3",
                                        "load_url": "/api/categories/$currentCategoryId/pages",
                                        "draggable": true,
                                        "children": [
                                        ],
                                    }
                                },
                                "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'News Title',
                                            "placeholder": 'Enter News Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "date": {
                                            "type": 'date',
                                            "label": 'Date',
                                            "placeholder": 'Enter Date',
                                            "required": true,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        "featured": {
                                            "type": 'toggle',
                                            "label": 'Featured',
                                            "placeholder": 'Select Featured',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        "url": {
                                            "type": 'slug',
                                            "label": 'Path',
                                            "url": "/patientnews/$slug",
                                            "placeholder": 'Enter Path / Slug',
                                            "required": false,
                                            "info": true,
                                            "character_count": 50,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "media_type": {
                                            "type": 'select',
                                            "label": 'Upload Options',
                                            "placeholder": 'Select Upload Option',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": "",
                                            "options": ['Video', 'Image']
                                        },
                                        "image_url": {
                                            "type": 'imgSelect',
                                            "label": 'Select Image',
                                            "placeholder": 'Select Image',
                                            "displayOn": "media_type",
                                            "displayOnValue": 'Image',
                                            "load_url": '',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        "video_url": {
                                            "type": 'vidText',
                                            "label": 'Video URL',
                                            "placeholder": 'Enter Video URL',
                                            "displayOn": "media_type",
                                            "displayOnValue": 'Video',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "description": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": false,
                                            "info": true,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                            },
                                    },
                                    "children": [
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        "title": "Alerts",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": true,
                            "activeToggle": false,
                            "deleteButton": true, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Alert",
                                "type": "page",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Alert Title',
                                    "placeholder": 'Enter Alert Title',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                    "practices": {
                                        "type": 'practiceMultiSelect',
                                        "label": 'Practice(s)',
                                        "placeholder": 'Select Practice',
                                        "load_url": '',
                                        "required": true,
                                        "info": false,
                                        "character_count": 0,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                },
                                "additionalProps": {
                                    "color":"Red",
                                    "further_details" : {
                                        "name": "External Link"
                                    },
                                    "news_item_id" : "",
                                    "news_item_url" : "",
                                    "global":true,
                                }
                            },
                        },
                        "children": [
                            {
                                "type": "alertsTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Select a Alert",
                                    "type": "list",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ],    
                                    "onlyGlobal": true,                                
                                    "isGlobal": true,
                                    "global": {
                                        "label": "Select a Alert",
                                        "type": "list",
                                        "info": true,
                                        "size": "4",
                                        "style": "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                        "class": "p-0 pt-3 pr-3",
                                        "load_url": "/api/categories/$currentCategoryId/pages",
                                        "draggable": true,
                                        "children": [
                                        ],
                                    }
                                },
                                "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Alert Title',
                                            "placeholder": 'Enter Alert Title',
                                            "required": true,
                                            "info": true,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "color": {
                                            "type": 'radio',
                                            "label": 'Colour',
                                            "placeholder": 'Enter Alert Title',
                                            "required": false,
                                            "info": true,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": "",
                                            "options": ['Red', 'Amber', 'Green']
                                        },
                                        "description": {
                                            "type": 'ckeditor',
                                            "label": 'Description',
                                            "placeholder": 'Enter Description',
                                            "required": false,
                                            "info": true,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "further_details": {
                                            "type": 'radioObject',
                                            "label": 'Further Details',
                                            "placeholder": 'Further Details',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": "",
                                            "options": [
                                                {
                                                  "name": 'Expand',
                                                },
                                                {
                                                  "name": 'News Item',
                                                },
                                                {
                                                  "name": 'External Link',
                                                }
                                              ]
                                        },
                                        "news_item_id": {
                                            "type": 'newsSelect',
                                            "label": 'Select News Item',
                                            "placeholder": 'Select News Item',
                                            "displayOn": "further_details",
                                            "displayOnValue": '{"name":"News Item"}',
                                            "load_url": '',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                        "news_item_url": {
                                            "type": 'text',
                                            "label": 'Enter Link Here',
                                            "placeholder": 'Enter / Paste Link',
                                            "displayOn": "further_details",
                                            "displayOnValue": '{"name":"External Link"}',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            }
                            
                            
                        ]
                    },
                ]
            }
        ]
    }
]

export { globalupdate };